import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';

interface ImageProps {
    images: string[];
}

export const ImageList = ({ images }: ImageProps) => {
    const [emblaRef] = useEmblaCarousel({
        dragFree: true,
        containScroll: 'trimSnaps',
    });

    return (
        <div className="w-full overflow-hidden" ref={emblaRef}>
            <div className="flex gap-[30px]">
                {images.map(image => (
                    <div
                        key={image}
                        className="relative flex-[0_0_80%] xs:flex-[0_0_45%] md:flex-[0_0_30%] xl:flex-[0_0_342px] max-h-[500px]"
                    >
                        <img
                            src={image}
                            alt="Customer_left_image"
                            className="w-full h-full object-fill"
                            onDragStart={e => e.preventDefault()}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};
